import React, { useMemo, useState } from 'react';
import { Button, makeStyles } from '@material-ui/core';

import classNames from 'classnames';

import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import { useLibrary } from '../../LibraryPage';
import { LibraryItem } from '../../../../entities/LibraryItem';
import { useHistory } from 'react-router-dom';
import { routes } from '../../../../routes';
import { FirstLayerMenu } from '../../AddNew/Components/FirstLayerMenu';

const useStyles = makeStyles((theme) => ({
    crumbs: {
        color: "#5f6368",
        fontSize: 18,
        fontWeight: 500,
        fontFamily: "Roboto, Helvetica",
        verticalAlign: "middle",
    },
    crumbButton: {
        borderRadius: 5,
        textTransform: "none",
        padding: 0
    }
}));

interface StructureParts {
    id: string | null;
    name: string;
}

const getFolderPath = (items:LibraryItem[], activeFolderId?:string) => {
    const folders:StructureParts[] = [];
    let folderId: string | undefined = activeFolderId;
    while(folderId !== undefined){
        const folder = items.find(i => i.id === folderId);
        if(folder){
            folders.push({id: folder.id, name: folder.name});
            folderId = folder.parentId;
        } else {
            folderId = undefined;
        }
    }
    folders.push({id: null, name: "My Library"});
    return folders.reverse();
}

export function BreadCrumbs() {
    const classes = useStyles();
    const history = useHistory();
    const context = useLibrary();

    const [anchor, setAnchor] = useState<HTMLElement>()

    const foldersInPath = useMemo(() => 
        getFolderPath(context.libraryItems.filter(i => i.type), context.activeFolderId ?? undefined)
    , [context.activeFolderId, context.libraryItems]);

    return (
        <div>
            {foldersInPath.map((item: StructureParts, index: number) => {
                return (
                    <span key={item.id}>
                        {context.activeFolderId !== item.id
                            &&
                            <Button
                                size="small"
                                className={classNames(classes.crumbs, classes.crumbButton)}
                                onClick={() => history.push(item.id ? routes.app.resolve.libraryFolder(item.id) : routes.app.libraryHomePage)}
                            >
                                <span className={classes.crumbs}>{item.name}</span>
                            </Button>
                        }
                        {context.activeFolderId === item.id
                            &&
                            <Button
                                size="small"
                                className={classNames(classes.crumbs, classes.crumbButton)}
                                onClick={(e) => setAnchor(e.currentTarget)}
                            >
                                <span className={classes.crumbs}>
                                    {item.name} <ArrowDropDownIcon style={{verticalAlign: "middle"}} /> </span>
                            </Button>

                        }
                        {index < foldersInPath.length - 1
                            &&
                            <ChevronRightIcon style={{ verticalAlign: "middle", color: "#5f6368"}}/>
                        }
                    </span>
                );
            })}
            {anchor && <FirstLayerMenu anchorElement={anchor} onClose={() => setAnchor(undefined)} />}
        </div>
    );
}